module.exports = __webpack_public_path__ + "static/media/Raju bhaiya-Model.93b42cd7.pdf";